import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { LANDING } from "@/constants/testIds";

export default function Nav({ scrolled }) {
  const [open, setOpen] = useState(false);
  const links = [
    { label: "About", href: "#about", testId: LANDING.navAbout },
    { label: "Contact", href: "#contact", testId: LANDING.navContact },
  ];

  return (
    <header
      data-testid={LANDING.nav}
      className={`sticky top-0 z-50 bg-white transition-shadow duration-300 ${
        scrolled ? "shadow-[0_4px_24px_-12px_rgba(14,14,14,0.18)]" : "border-b border-[#E6E3D9]"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 lg:px-12 flex items-center justify-between h-[68px] md:h-[76px]">
        <a href="#top" data-testid={LANDING.navLogo} className="flex items-center gap-3 group">
          <div className="w-9 h-9 bg-[#FFE512] flex items-center justify-center font-display text-[#0E0E0E] text-[15px] font-semibold rounded-sm">
            JT
          </div>
          <div className="leading-tight">
            <div className="font-display text-[18px] tracking-tight text-[#0E0E0E]">
              James Townsend
            </div>
            <div className="font-sans-tight text-[10px] uppercase tracking-[0.22em] text-[#888880]">
              Licensee Salesperson
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={l.testId}
              className="relative font-sans-tight text-[14px] font-medium text-[#0E0E0E] py-2 group"
            >
              {l.label}
              <span className="absolute -bottom-0.5 left-0 right-0 mx-auto w-0 h-[2px] bg-[#FFE512] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#contact"
            data-testid={LANDING.navCallBtn}
            className="hidden sm:inline-flex btn btn-yellow"
          >
            Get sales appraisal
            <ArrowUpRight className="w-4 h-4" />
          </a>
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden w-10 h-10 rounded-sm border border-[#0E0E0E] flex items-center justify-center"
            aria-label="Menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#E6E3D9] px-5 py-4">
          <div className="flex flex-col">
            {links.map((l) => (
              <a key={l.label} href={l.href} onClick={() => setOpen(false)} className="py-3 font-display text-xl border-b border-[#E6E3D9] last:border-0">
                {l.label}
              </a>
            ))}
            <a href="#contact" onClick={() => setOpen(false)} className="mt-4 btn btn-yellow justify-center">
              Get sales appraisal
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
